import Vue from 'vue'
// import '@/plugins/component-library.js'
import '@gravela/vue-component-library/src/plugins/flag-icon.js'
import '@gravela/vue-component-library/src/plugins/oauth2.js'
import '@/plugins/basket.js'
import '@gravela/vue-component-library/src/plugins/countries.js'
import '@/plugins/customer.js'
import '@gravela/vue-component-library/src/plugins/institution.js'
import '@/plugins/idlevue.js'
import '@gravela/vue-component-library/src/plugins/iframe.js'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n.js'
import router from '@/plugins/router.js'
// import store from '@/plugins/store'
import App from './AppChipmunk.vue'
require('@/assets/styles/global-style.scss')
require('@/filters.js')

Vue.config.productionTip = false

export const eventBus = new Vue()

new Vue({
  vuetify,
  router,
  i18n,
  // store,
  render: h => h(App)
}).$mount('#app')
